import React from "react";
import { MapPin, List, Gift } from "react-feather";
import locationMenuCfg from "../../Config/locationMenu.json";
import { MY_WORLDS } from "./Menu";
import { isLocationSidebarContext } from "../../helpers/locationContext";

const ICONS = {
  MapPin: <MapPin />,
  List: <List />,
  Gift: <Gift />,
};

const getPublicBase = () => {
  const p = process.env.PUBLIC_URL || "";
  return p.replace(/\/$/, "");
};

const buildUrl = (relativePath, locationId) => {
  const base = getPublicBase();
  const path = relativePath.replace(/^\//, "");
  const prefix = base === "" ? "" : base;
  const slash = prefix === "" ? "/" : `${prefix}/`;
  return `${slash}${path}?location_id=${locationId}`;
};

const buildLocationMenuSections = (locationId) =>
  locationMenuCfg.sections.map((section) => ({
    title: section.title,
    icon: ICONS[section.icon] || ICONS.MapPin,
    class: "lan-3",
    menu: section.links.map((link) => ({
      title: link.title,
      type: "link",
      url: buildUrl(link.path, locationId),
    })),
  }));

/**
 * Сайдбар: один menu-box — «Платформа» и при контексте локации секции из locationMenu.json.
 */
export const buildSidebarMenu = (pathname, search) => {
  /* Две группы с подписями: слева должно быть видно, где личные данные,
     а где работа над мирами. */
  /* Личные разделы (профиль, кошелёк, документы) переехали в меню под
     аватаркой — Максим 22.08.2026. Слева остаётся только работа над
     мирами, поэтому подпись группы больше не нужна: делить нечего. */
  const base = [{ className: "menu-box", menu: MY_WORLDS.slice() }];

  if (!isLocationSidebarContext(pathname, search)) {
    return base;
  }

  const id = parseInt(new URLSearchParams(search).get("location_id"), 10);
  if (Number.isNaN(id) || id < 1) {
    return base;
  }

  /* В контексте локации к группам добавляется третья — разделы самого мира. */
  return [
    ...base,
    {
      className: "menu-box",
      groupTitle: "Этот мир",
      menu: buildLocationMenuSections(id),
    },
  ];
};
